export const collabActionTypes = {
    COLLAB_JOIN_ROOM:        'COLLAB_JOIN_ROOM',
    COLLAB_LEAVE_ROOM:       'COLLAB_LEAVE_ROOM',
    COLLAB_ROOM_JOINED:      'COLLAB_ROOM_JOINED',
    COLLAB_ROOM_LEFT:        'COLLAB_ROOM_LEFT',
    COLLAB_JOIN_FAILED:      'COLLAB_JOIN_FAILED',
    COLLAB_DOC_UNAUTHORIZED: 'COLLAB_DOC_UNAUTHORIZED',
    COLLAB_RESET:            'COLLAB_RESET',
};
